/**
 * @see {@link https://www.w3.org/WAI/ARIA/apg/patterns/accordion/}
 */
import {
    getAriaControlsElements,
    getAriaExpanded,
    setAriaExpanded,
} from "./base";

export function isAccordionHeader(element: HTMLElement): element is HTMLButtonElement {
    return (
        element instanceof HTMLButtonElement &&
        element.hasAttribute("aria-controls") &&
        element.hasAttribute("aria-expanded")
    );
}

export function toggleAccordionPanel(toggle: HTMLButtonElement) {
    if (getAriaExpanded(toggle)) {
        setAriaExpanded(toggle, false);
        for (const region of getAriaControlsElements(toggle)) {
            region.hidden = true;
        }
    } else {
        setAriaExpanded(toggle, true);
        for (const region of getAriaControlsElements(toggle)) {
            region.removeAttribute("hidden");
        }
    }
}
